import { render, staticRenderFns } from "./HkBreadcrumb.vue?vue&type=template&id=2c8660a0&scoped=true&"
import script from "./HkBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./HkBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./HkBreadcrumb.vue?vue&type=style&index=0&id=2c8660a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8660a0",
  null
  
)

export default component.exports